var exports = {
  "fU": "xf0b3b88a--228bbf--promo-info",
  "n5": "xf0b3b88a--228bbf--promo-info-text",
  "hv": "xf0b3b88a--228bbf--promo-sale-info",
};

module.exports = exports;
